import React from 'react'
import { Flag, FlagNameValues } from 'semantic-ui-react'

const CountryCodeCell: React.FC<{ content: string }> = props => {
  //  do mulitple cleanups to get the actual country code
  const [, splittedFromEnum] = props.content.toUpperCase().split('||')
  const countryCode = (splittedFromEnum || props.content || '').toLowerCase().replace('enum.enumcountrycode_', '')

  return !countryCode ? null : (
    <React.Fragment>
      <Flag name={countryCode as FlagNameValues} /> {countryCode.toUpperCase()}
    </React.Fragment>
  )
}

CountryCodeCell.defaultProps = {
  content: ''
}

CountryCodeCell.displayName = 'CountryCodeCell'

export default CountryCodeCell
